import { SxProps, Theme } from '@mui/material';
import { footerTypographyUppercaseBaseSX } from '@/components/content/Footer/styles/general';

export const footerCallCenterTitleSX: SxProps = {
	...footerTypographyUppercaseBaseSX,
	mb: 0.5,
};

export const footerCallCenterReceiveOffersTitleSX: SxProps = {
	...footerTypographyUppercaseBaseSX,
	marginBottom: '10px',
};

export const footerCallCenterPhoneBaseSX: SxProps<Theme> = {
	color: '#0064C7',
	fontWeight: 'bold',
	display: 'flex',
	fontSize: { xs: 'var(--font-size-xl)', sm: '19px'},
	alignItems: 'center',
};

export const footerCallCenterPhoneTextSX: SxProps<Theme> = {
	...footerCallCenterPhoneBaseSX,
};

export const footerCallCenterPhoneTextMobileSX: SxProps<Theme> = {
	...footerCallCenterPhoneBaseSX,
	fontSize: 'var(--font-size-xl)',
	gap: 0.2,
};

export const footerMobileCallCenterFrameSX: SxProps = {
	borderBottom: '1px solid rgba(0, 0, 0, .125)',
	paddingBottom: '1rem',
};
